import { useCallback } from 'react';
import { Language } from 'src/shared/constants/languages';
export function useLocaleFile(language) {
    const getLocaleFile = useCallback(async function getLocaleFile() {
        switch (language) {
            case Language.Es: {
                const { Spanish } = await import('flatpickr/dist/l10n/es');
                return Spanish;
            }
            case Language.Fr: {
                const { French } = await import('flatpickr/dist/l10n/fr');
                return French;
            }
            case Language.PtBr: {
                const { Portuguese } = await import('flatpickr/dist/l10n/pt');
                return Portuguese;
            }
            default:
                return undefined;
        }
    }, [language]);
    return { getLocaleFile };
}
